import React from "react";
import LanguageComponent from "../../../Components/LangTranslation/LanguageComponent";
import LeftLayout from "../../../Components/LeftLayout";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../Components/LangTranslation/LanguageContext";

const OnboardingButton = styled.button`
  width: 65%;
  height: 60px;
  border-radius: 14px;
  font-family: "Comfortaa", sans-serif;
  background-color: #000000; /* VTEX background color */
  color: ${(props) => props.theme.primaryColor.primary}; /* VTEX text color */
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  border-width: 0;
  margin-top: 65px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 768px) {
    width: 90%;
    font-size: 16px;
  }
`;

const OnboardingInfo = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    navigate("/signup");
  };

  return (
    <div className="onb-info-main-wrapper">
      <div className="mx-4 onb-info-small">
        <div className="required-info-wrapper d-flex flex-column justify-content-start mx-3 mt-4">
          <h4 className="fw-bold" style={{ fontFamily: "Comfortaa" }}>
            {t["Required Information to Onboarding"]}
          </h4>
          <ul style={{ fontFamily: "Comfortaa" }}>
            <li className="fw-bold">{t["Full Name"]}</li>
            <li className="fw-bold">{t["Email Address"]}</li>
            <li className="fw-bold">{t["Phone Number"]}</li>
            <li className="fw-bold">{t["Business Name"]}</li>
            <li className="fw-bold">{t["Pickup Address"]}</li>
            <li className="fw-bold">{t["Bank Information"]}</li>
          </ul>
        </div>
        <div className="required-doc-wrapper d-flex flex-column justify-content-start mx-3 mt-4">
          <h4 className="fw-bold" style={{ fontFamily: "Comfortaa" }}>
            {t["Required Document to Onboarding"]}
          </h4>
          <ul style={{ fontFamily: "Comfortaa" }}>
            <li className="fw-bold">{t["Commercial Registration Number"]}</li>
            <li className="fw-bold">{t["Chamber of Commerce"]}</li>
            <li className="fw-bold">{t["VAT Certification"]}</li>
          </ul>
        </div>
      </div>
      <LeftLayout>
        <div className="d-flex flex-column mx-4">
          <div className="required-info-wrapper d-flex flex-column justify-content-start mx-3 mt-4">
            <h4 className="fw-bold" style={{ fontFamily: "Comfortaa" }}>
              {t["Required Information to Onboarding"]}
            </h4>
            <ul style={{ fontFamily: "Comfortaa" }}>
              <li className="fw-bold">{t["Full Name"]}</li>
              <li className="fw-bold">{t["Email Address"]}</li>
              <li className="fw-bold">{t["Phone Number"]}</li>
              <li className="fw-bold">{t["Business Name"]}</li>
              <li className="fw-bold">{t["Pickup Address"]}</li>
              <li className="fw-bold">{t["Bank Information"]}</li>
            </ul>
          </div>
          <div className="required-doc-wrapper d-flex flex-column justify-content-start  mx-3">
            <h4 className="fw-bold" style={{ fontFamily: "Comfortaa" }}>
              {t["Required Document to Onboarding"]}
            </h4>
            <ul style={{ fontFamily: "Comfortaa" }}>
              <li className="fw-bold">{t["Commercial Registration Number"]}</li>
              <li className="fw-bold">{t["Chamber of Commerce"]}</li>
              <li className="fw-bold">{t["VAT Certification"]}</li>
            </ul>
          </div>
        </div>
      </LeftLayout>

      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <LanguageComponent />
      </div>
      <div className="get-started-btn-wrapper d-flex flex-column justify-content-center align-items-center w-50 mx-auto">
        <h2 className="get-started-label fw-bold">{t["Register Now"]}</h2>
        <OnboardingButton onClick={handleSignUpClick}>
          {t["Click here to reigster"]}
        </OnboardingButton>
      </div>
    </div>
  );
};

export default OnboardingInfo;
